// src/components/BoardOfEd/components/Program1600.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_1600_CONFIG = {
  fullName: "HEALTH SERVICES",
  docId: "1600",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsNurses",
      label: "Positions – Nurses",
      valueType: "count",
      sources: [{ block: "Positions", key: "Nurses" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesNurses",
      label: "Salaries – Nurses",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Nurses" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaProfessional",
      label: "Salaries – ParaProfessional",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "ParaProfessional" },
        { block: "Salaries", key: "Paraprofessional" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesNursesPT",
      label: "Salaries – Nurses P-T",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Nurses P-T" },
        { block: "Salaries", key: "Nurses, P-T" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSummerHelp",
      label: "Salaries – Summer Help",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Summer Help" }],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "medicalAdvisor",
      label: "Purchased Services – Medical Advisor",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Medical Advisor" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "liabilityInsurance",
      label: "Purchased Services – Liability Insurance",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Liability Insurance" }],
      group: "services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "supplies",
      label: "Supplies",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Supplies" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "publications",
      label: "Publications",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Publications" }],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "travel",
      label: "Travel",
      valueType: "currency",
      sources: [{ block: "Other", key: "Travel" }],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        "positionsNurses",
        "salariesNurses",
        "salariesParaProfessional",
        "salariesNursesPT",
        "salariesSummerHelp",
        "medicalAdvisor",
        "liabilityInsurance",
        "supplies",
        "publications",
        "travel",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsNurses: { minWidth: "120px" },

        // Salaries
        salariesNurses: { minWidth: "130px" },
        salariesParaProfessional: { minWidth: "140px" },
        salariesNursesPT: { minWidth: "130px" },
        salariesSummerHelp: { minWidth: "130px" },

        // Services
        medicalAdvisor: { minWidth: "150px" },
        liabilityInsurance: { minWidth: "150px" },

        // Materials / Other
        supplies: { minWidth: "110px" },
        publications: { minWidth: "110px" },
        travel: { minWidth: "90px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        "positionsNurses",
        "salariesNurses",
        "salariesParaProfessional",
        "salariesNursesPT",
        "salariesSummerHelp",
        "medicalAdvisor",
        "liabilityInsurance",
        "supplies",
        "publications",
        "travel",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsNurses: { minWidth: "120px" },

        // Salaries
        salariesNurses: { minWidth: "130px" },
        salariesParaProfessional: { minWidth: "140px" },
        salariesNursesPT: { minWidth: "130px" },
        salariesSummerHelp: { minWidth: "130px" },

        // Services
        medicalAdvisor: { minWidth: "150px" },
        liabilityInsurance: { minWidth: "150px" },

        // Materials / Other
        supplies: { minWidth: "110px" },
        publications: { minWidth: "110px" },
        travel: { minWidth: "90px" },
      },
    },
  ],
};

export function Program1600(props) {
  return (
    <ProgramBudget programId="1600" config={PROGRAM_1600_CONFIG} {...props} />
  );
}
